import { useRef, useEffect } from 'react';

const CharacterVideo = ({ src, active = true }) => {
    const videoRef = useRef(null);

    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        if (active) {
            v.play().catch(() => {});
        } else {
            v.pause();
        }
    }, [active]);

    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        v.play().catch(() => {
            const resume = () => v.play().catch(() => {});
            document.addEventListener('touchstart', resume, { once: true });
            document.addEventListener('click', resume, { once: true });
        });
    }, [src]);

    return (
        <video
            ref={videoRef}
            src={src}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
    );
};

export default CharacterVideo;